module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA8klEQVQ4T+2TsWoCURBF7wRc/QC/wTpNCsG/sEi3+wa2tgvphLS2qbaat4tVinyCWPsLtnaCYGWxsFe2CesS8YFLQiBTvpk53Jl3R9BxSMc8/CGgL/yc5Ns9K9BE5Wtky433wOreXwRWGKnqtlZhhW1APH03TZhCwVRj/WwCrq0nCFgXtdVYbicAg/Z7EBDAuyY660xhDaKwKE9lGkXRIx6wueaGUIXBbvoH/uDpCWSZxElsSxtLJWsAvZuX4nO/JzhsFgrl2Tn30W7OsqzXH/RXBCfN3MUvkxRf+B3BY1VWkzRNDyF+sdxeACxE5NXFbnEGk25+FeeBn5kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about-c_icon_cp_noe.png
// module id = vpsC
// module chunks = 1